import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { LayoutComponent } from './layout';
import { AppRoutes } from './app-routes';
import { AdminLayoutComponent } from './admin-layout';
import { EUserRole, RoleGuard } from './core';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./redirect').then(m => m.RedirectModule),
  },
  {
    path: 'doctor',
    component: LayoutComponent,
    canActivate: [RoleGuard],
    data: { roles: [EUserRole.DOCTOR] },
    children: [
      {
        path: '',
        redirectTo: `/doctor/${AppRoutes.PATIENTS}`,
        pathMatch: 'full',
      },
      {
        path: `${AppRoutes.PATIENTS}`,
        loadChildren: () =>
          import('./pages/patients').then(m => m.PatientsModule),
      },
      {
        path: `${AppRoutes.PATIENTS}/:id`,
        loadChildren: () =>
          import('./pages/patient-details').then(m => m.PatientDetailsModule),
      },
      {
        path: `${AppRoutes.PATIENTS}/:id/${AppRoutes.SAMPLES}/:sampleId`,
        loadChildren: () =>
          import('./pages/patient-samples').then(m => m.PatientSamplesModule),
      },
    ],
  },
  {
    path: 'admin',
    component: AdminLayoutComponent,
    canActivate: [RoleGuard],
    data: { roles: [EUserRole.ADMIN] },
    children: [
      {
        path: '',
        redirectTo: `/admin/${AppRoutes.DOCTORS}`,
        pathMatch: 'full',
      },
      {
        path: AppRoutes.DOCTORS,
        loadChildren: () =>
          import('./pages/doctors').then(m => m.DoctorsModule),
      },
      {
        path: AppRoutes.DEVICES,
        loadChildren: () =>
          import('./pages/devices').then(m => m.DevicesModule),
      },
    ],
  },
  { path: '**', redirectTo: '/' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      initialNavigation: 'enabledNonBlocking',
      preloadingStrategy: PreloadAllModules,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
